import type { MetaInfo } from 'vue-meta';
import { buildSeoHead } from '~/helpers/buildSeoHead';

export const getMetaInfo = (page: any, isNoIndex: boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  return buildSeoHead({
    title: page?.meta_title || page?.title || page?.name,
    description: page?.meta_description,
    keywords: page?.meta_keyword || page?.meta_keywords,
    isNoIndex,
  });
};
